var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.shouldDelayHydration)?_c('delay-hydration',[_c('nuxt')],1):_c('nuxt'),_vm._v(" "),(_vm.showCookieConsent)?_c('CookieConsent'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }